import React from "react";
import person from "@me-team/host/src/images/person.jpg";
import { TooltipAvailableBranches } from "../index";
import { UserBranchRelationProxy } from "@me-team/host/main/graphql/types";
import { Link, useParams } from "react-router-dom";

interface EmployeeInfoProps {
    name: string;
    surname: string;
    position: string;
    image: string;
    userBranchRelations: UserBranchRelationProxy[];
    link?: boolean;
    idEmployee?: string | number;
}

const EmployeeInfo: React.FC<EmployeeInfoProps> = ({
    name,
    surname,
    position,
    image,
    userBranchRelations,
    link,
    idEmployee,
}) => {
    const { branchId } = useParams();
    return (
        <div className="d-flex align-items-center">
            {image ? (
                <div>
                    <img
                        className="img-employ-list rounded-circle d-flex"
                        src={`${process.env.REACT_APP_POS_URL}/${image}`}
                        alt="Avatar"
                        width="40px"
                        height="40px"
                    />
                </div>
            ) : (
                <div>
                    <img
                        className="img-employ-list rounded-circle"
                        src={person}
                        alt="Avatar"
                        width="40px"
                        height="40px"
                    />
                </div>
            )}

            <div className="ms-2">
                <p className="mb-0 d-flex text-dark">
                    {link ? (
                        <Link
                            to={`/employees-list/edit-employee/${idEmployee}/${branchId}`}
                            className="text-decoration-none text-dark"
                        >
                            <p className="mb-0 fs-16">
                                {name} {surname}
                            </p>
                        </Link>
                    ) : (
                        <p className="mb-0 fs-16">
                            {name} {surname}
                        </p>
                    )}
                    <TooltipAvailableBranches userBranchRelations={userBranchRelations}>
                        <i className="bi bi-info-circle text-dark ms-2 align-self-center fs-7 pe-2"></i>
                    </TooltipAvailableBranches>
                </p>
                <span className="text-grey fs-7">{position}</span>
            </div>
        </div>
    );
};

export default EmployeeInfo;
